import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { toast } from 'sonner';

interface UserRegistrationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export function UserRegistrationModal({ isOpen, onClose }: UserRegistrationModalProps) {
  const [formData] = useState({
    email: '',
    password: '',
    name: '',
    dateOfBirth: '',
    nationality: '',
    role: 'traveler' as const
  });

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/v1/users/register', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (!response.ok) throw new Error('Registration failed');

      toast.success('Registration successful! Welcome to Wildlife Journey!');
      onClose();
    } catch (error) {
      toast.error('Failed to register');
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[400px] p-6">
        <DialogHeader>
          <DialogTitle>Create Your Account</DialogTitle>
          <DialogDescription>
            Join Wildlife Journey as a traveler
          </DialogDescription>
        </DialogHeader>

        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Form fields */}
        </form>
      </DialogContent>
    </Dialog>
  );
}